import React from "react";

// components
import { CgMenuLeftAlt, CgMenuRight } from "react-icons/cg";

// react router navigation
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_profile } from "../../../services/apis/setting";
import { logout } from "../../../services/apis/auth";

type INavbar = {
  open: boolean;
  setOpen: () => void;
};

const Navbar: React.FC<INavbar> = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const profile = useAppSelector(({ setting }) => setting.profile);

  const onLoad = React.useCallback(() => {
    get_profile(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout failed", error);
    } finally {
      navigate("/login", { replace: true });
    }
  };

  return (
    <header className="w-full flex justify-between items-center bg-white shadow-sm px-4">
      <div className="cursor-pointer">
        {open ? (
          <CgMenuRight size={24} onClick={setOpen} />
        ) : (
          <CgMenuLeftAlt size={24} onClick={setOpen} />
        )}
      </div>

      <div className="flex gap-x-3 items-center">
        <img
          src={profile?.profile?.avatar}
          alt={profile?.profile?.name}
          className="w-[2.5rem] h-[2.5rem] rounded-full cursor-pointer border"
          onClick={() => navigate("/profile")}
        />

        <span className="cursor-pointer" onClick={handleLogout}>
          Logout
        </span>
      </div>
    </header>
  );
};

export default Navbar;
